/* eslint-disable */
// src/context/TenantContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { getTenantFromUrl } from '../utils/tenant';
import TenantNotFound from '../components/commons/TenantNotFound';

const TenantContext = createContext({
    isTenant: false,
    tenantSlug: null,
    orgData: null,
    loading: false,
    notFound: false,
});

export function TenantProvider({ children }) {
    const [{ isTenant, tenantSlug }] = useState(() => getTenantFromUrl());
    const [orgData, setOrgData] = useState(null);
    const [loading, setLoading] = useState(isTenant);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!isTenant || !tenantSlug) {
            setLoading(false);
            return;
        }

        // Fetch organisation public branding/metadata by slug
        axios
            .get(`${process.env.REACT_APP_BASE_URL}/v3/organizations/public/${tenantSlug}`)
            .then((res) => {
                if (res.data && (res.data.name || res.data.id)) {
                    setOrgData(res.data);
                    setNotFound(false);
                } else {
                    setOrgData(null);
                    setNotFound(true);
                }
            })
            .catch((err) => {
                console.error('Failed to load org branding:', err);
                setOrgData(null);
                setNotFound(true);
            })
            .finally(() => setLoading(false));
    }, [isTenant, tenantSlug]);

    // 1. While resolving the organisation, prevent mounting the app
    if (isTenant && loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    width: '100vw',
                    backgroundColor: '#ffffff',
                }}
            >
                <div
                    style={{
                        width: '40px',
                        height: '40px',
                        border: '3px solid #e2e8f0',
                        borderTop: '3px solid #0055A2',
                        borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite',
                    }}
                />
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    // 2. If this is a tenant subdomain and the organisation does not exist, block access entirely
    if (isTenant && notFound) {
        return <TenantNotFound slug={tenantSlug} />;
    }

    return (
        <TenantContext.Provider value={{ isTenant, tenantSlug, orgData, loading, notFound }}>
            {children}
        </TenantContext.Provider>
    );
}

export const useTenant = () => useContext(TenantContext);
